import { motion } from "framer-motion";
import { PILLARS } from "../lib/constants";

export default function Pillars() {
  return (
    <section className="relative py-24 bg-[#0C1424]" data-testid="pillars-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14">
          <div className="font-mono2 text-xs tracking-[0.3em] uppercase text-[#0066FF] mb-3">
            What We Stand For
          </div>
          <h2 className="font-display text-4xl sm:text-5xl uppercase leading-none">
            The Pillars of <span className="text-[#0066FF]">Change</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`pillar-card-${p.id}`}
                className="group relative rounded-xl border border-[#0066FF]/15 bg-[#121D33] p-7 overflow-hidden hover:border-[#0066FF]/50 transition-colors"
              >
                <div
                  className="absolute -top-10 -right-10 h-32 w-32 rounded-full blur-2xl opacity-0 group-hover:opacity-30 transition-opacity"
                  style={{ background: p.color }}
                />
                <div
                  className="flex h-14 w-14 items-center justify-center rounded-lg mb-6"
                  style={{ background: `${p.color}1a`, border: `1px solid ${p.color}55` }}
                >
                  <Icon className="h-7 w-7" style={{ color: p.color }} />
                </div>
                <h3 className="font-cond font-bold uppercase text-xl tracking-wide mb-2">{p.name}</h3>
                <p className="text-sm text-[#94A3B8] leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
